import { Editor } from "@tiptap/core";
import React, { createContext, useContext, useState } from "react";
import { ReactFlowInstance } from "reactflow";

type ActiveEditorContextType = {
  activeEditor: Editor | undefined;
  setActiveEditor: React.Dispatch<React.SetStateAction<Editor | undefined>>;
  id: string | undefined;
  setId: React.Dispatch<React.SetStateAction<string | undefined>>;
  activeGraph: ReactFlowInstance | undefined;
  setActiveGraph: React.Dispatch<
    React.SetStateAction<ReactFlowInstance | undefined>
  >;
};

export const ActiveEditorContext = createContext<
  ActiveEditorContextType | undefined
>(undefined);

export function ActiveEditorProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [activeEditor, setActiveEditor] = useState<Editor>();
  const [activeGraph, setActiveGraph] = useState<ReactFlowInstance>();
  const [id, setId] = useState<string>();

  const value = {
    activeEditor,
    setActiveEditor,
    id,
    setId,
    activeGraph,
    setActiveGraph,
  };

  return (
    <ActiveEditorContext.Provider value={value}>
      {children}
    </ActiveEditorContext.Provider>
  );
}

/**
 * Hook for sharing editor between components
 */
export default function useActiveEditor() {
  const context = useContext(ActiveEditorContext);

  if (!context) {
    throw new Error(
      `useActiveEditor must be used within a ActiveEditorProvider`
    );
  }

  return context;
}
